export const MediaEndpoints = {
  upload: '/media/upload',
  remove: '/media/remove'
}
